module.exports = __webpack_public_path__ + "img/437.531ad6f2.jpg";